import { atom } from "jotai";
import type { LocationResponse } from "@models/location";

export const locationsAtom = atom<LocationResponse[]>([]);

// Whether GET /locations has ever answered successfully. locationsAtom's own `[]` cannot say:
// it is both "never read" and "read, and you have none", and those two demand opposite
// treatment of a stored ship-to destination (#228 / E4-S12). Set by useLocationApi.getLocations,
// so every one of its five call sites produces the fact rather than only the header's.
export const locationsLoadedAtom = atom<boolean>(false);

export const isFetchingLocationsAtom = atom<boolean>(false);

export const locationsFetchErrorAtom = atom<boolean>(false);

export const isProcessingLocationsAtom = atom<boolean>(false);
